import { default as CurrencyInputField } from 'react-currency-input-field';
import { mapClasses } from '../../utils/styles';
import './style.scss';

type Props = {
  disabled?: boolean;
  state?: 'success' | 'error';
  value: string | number;
  onChange?: (value: string) => void;
  autoFocus?: boolean;
  decimalsLimit?: number;
  currencySymbol?: string;
  onBlur?: (value: string) => void;
};

export const CurrencyInput = ({
  disabled,
  state,
  autoFocus,
  value,
  onChange,
  onBlur,
  decimalsLimit = 2,
  currencySymbol = '',
}: Props) => {
  const classes = mapClasses({ disabled, state });

  return (
    <div className={`tru-currency-input ${disabled ? 'disabled' : ''} `}>
      <span className="currency"> {currencySymbol} </span>
      <CurrencyInputField
        defaultValue={value}
        value={value}
        decimalsLimit={decimalsLimit}
        onValueChange={(value: string | undefined) => {
          onChange?.(value!);
        }}
        allowNegativeValue={false}
        onBlur={() => onBlur?.(value as string)}
        className={`tru-text-input ${classes}`}
        disabled={disabled}
        autoFocus={autoFocus}
      />
    </div>
  );
};
